<template>
  <zm-context :system-fonts="false" :namespace="NAME_SPACE">
    <header class="delegate-common-header">
      <div class="delegate-common-header__left">
        <div id="common-header-logo-container" class="delegate-common-header__logo">
          <a href="/" target="_self" class="delegate-common-header__logo-image">
            <svg
              viewBox="0 0 114 26"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="xMidYMid meet">
              <path
                d="m23.6977 25.2924h-20.10301c-1.32885 0-2.58954-.6978-3.202853-1.8892-.698493-1.3617-.4429462-2.9956.630343-4.068l13.98692-13.97375h-10.01743c-2.7599 0-4.99167-2.22968-4.99167-4.987h18.5186c1.3288 0 2.5895.69784 3.2028 1.88927.6986 1.36164.443 2.9956-.6303 4.0679l-13.98691 13.97378h11.60181c2.7599 0 4.9917 2.2297 4.9917 4.987zm79.5603-25.2924c-2.879 0-5.4691 1.24249-7.241 3.23389-1.7883-1.9914-4.3781-3.23389-7.2401-3.23389-5.3497 0-9.7108 4.56149-9.7108 9.88887v15.40353c2.7598 0 4.9915-2.2297 4.9915-4.987v-10.46757c0-2.5701 1.9933-4.74871 4.5487-4.85083 2.692-.10213 4.9237 2.05945 4.9237 4.73169v10.58671c0 2.7573 2.2317 4.987 4.9915 4.987v-15.45457c0-2.5701 1.9935-4.74871 4.5485-4.85083 2.692-.10213 4.924 2.05945 4.924 4.73169v10.58671c0 2.7573 2.232 4.987 4.991 4.987v-15.40353c-.017-5.32738-4.378-9.88887-9.727-9.88887zm-54.3805 12.8334c0 7.0806-5.7583 12.8335-12.8455 12.8335-7.0871 0-12.8454-5.7529-12.8454-12.8335 0-7.0805 5.7753-12.8334 12.8454-12.8334 7.0702 0 12.8455 5.7529 12.8455 12.8334zm-4.9917 0c0-4.32315-3.5265-7.8464-7.8538-7.8464-4.3272 0-7.8538 3.52325-7.8538 7.8464 0 4.3233 3.5266 7.8465 7.8538 7.8465 4.3273 0 7.8538-3.5232 7.8538-7.8465zm32.6758 0c0 7.0806-5.758 12.8335-12.8451 12.8335-7.0877 0-12.8458-5.7529-12.8458-12.8335 0-7.0805 5.7757-12.8334 12.8458-12.8334 7.0696 0 12.8451 5.7529 12.8451 12.8334zm-4.9915 0c0-4.32315-3.5264-7.8464-7.8536-7.8464-4.3273 0-7.8541 3.52325-7.8541 7.8464 0 4.3233 3.5268 7.8465 7.8541 7.8465 4.3272 0 7.8536-3.5232 7.8536-7.8465z"
                fill="#0b5cff"></path>
            </svg>
          </a>
        </div>
      </div>
      <div class="delegate-common-header__center">
        <span class="delegate-common-header__logo-text">{{ logoText }}</span>
        <span class="delegate-common-header__account-name">{{ loginAccountName }}</span>
      </div>
      <div class="delegate-common-header__right">
        <zm-button
          type="secondary"
          neutral
          :loading="isLoading"
          data-id="back-button"
          @click="handleBack">
          {{ $t('backMainAccount') }}
        </zm-button>
      </div>
    </header>
  </zm-context>
</template>

<script setup>
import { useAdminBackButton } from './use-admin-back-button'
import { getContext } from '../../../commons/portal-init/get-context'
import { getLogoMainText } from './config.js'
import { NAME_SPACE } from '../../../commons/constants'
import { addClass, hasClass } from '@zoom/zoom-ui-vue3'
import { onMounted } from 'vue'
const ctx = getContext()
const logoText = getLogoMainText(ctx)
const { loginAccountName } = ctx
const { handleBack, isLoading } = useAdminBackButton()
onMounted(() => {
  const body = document.body
  if (!hasClass(body, 'is-delegate-view')) {
    addClass(body, 'is-delegate-view')
  }
})
</script>

<style lang="scss" scoped>
.delegate-common-header {
  display: flex;
  align-items: center;
  min-height: 64px;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  background-color: #fff9f2;
}
#super-sidebar-toggle-button-wrapper + .delegate-common-header__logo {
  margin-left: 12px;
}
.delegate-common-header__logo-image {
  display: flex;
  align-items: center;
}
.delegate-common-header__logo-image svg {
  height: 25px;
}

.delegate-common-header__center {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 20px;
  line-height: 24px;
}
.delegate-common-header__left {
  padding-right: 12px;
  display: flex;
  align-items: center;
}
.delegate-common-header__right {
  margin-left: auto;
}
.delegate-common-header__account-name {
  font-weight: 700;
  color: #222325;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.delegate-common-header__logo-text {
  font-weight: 400;
  color: #b36200;
  position: relative;
  line-height: 1;
  display: flex;
  align-items: center;
  padding-left: 12px;
}
.delegate-common-header__logo-text:before {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 20px;
  background-color: var(--zoom-color-border-subtle-neutral);
  margin-right: 12px;
}
@media screen and (max-width: 1023px) {
  .delegate-common-header {
    background-color: #fff;
    flex-wrap: wrap;
    padding-left: 0;
    padding-right: 0;
  }
  .delegate-common-header__center {
    width: 100%;
    background-color: #fff9f2;
    order: 3;
    flex-basis: 100%;
    padding: 16px;
    border-top: 1px solid #dfe3e8;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
  }

  .delegate-common-header__left {
    order: 1;
    margin-left: 16px;
    height: 64px;
  }

  .delegate-common-header__right {
    margin-right: 16px;
    order: 2;
    height: 64px;
    display: flex;
    align-items: center;
  }
}
@media screen and (max-width: 1024px) {
  :global(.is-simplified-portal.is-delegate-view #content .mini-layout-body > .row .nav-menu) {
    top: 120px;
  }
}
</style>
